import Button from 'antd/lib/button';
import React from 'react';

export type TSidebarActions = 'saveFilters' | 'clearFilters' | 'resetGrid';

interface ISidebarFilterActionsProps {
    isSaveDisabled?: boolean;
    shownActions: TSidebarActions[];
    onSaveFilters: () => void;
    onClearFilters: () => void;
    onResetGrid?: () => void;
}

export const SidebarFilterActions: React.FC<ISidebarFilterActionsProps> = ({
    isSaveDisabled = true,
    shownActions = [],
    onSaveFilters,
    onClearFilters,
    onResetGrid,
}) => {
    return (
        <div style={{ display: 'flex', padding: '8px', borderTop: '1px solid #d9d9d9', marginTop: 'auto' }}>
            {shownActions.includes('saveFilters') && (
                <Button disabled={isSaveDisabled} color="primary" variant="outlined" onClick={() => onSaveFilters()}>
                    Save Filters
                </Button>
            )}

            {shownActions.includes('clearFilters') && (
                <Button type="text" color="default" onClick={() => onClearFilters()} style={{ marginLeft: 'auto' }}>
                    Clear Filters
                </Button>
            )}

            {shownActions.includes('resetGrid') && (
                <Button type="text" color="default" onClick={() => onResetGrid && onResetGrid()} style={{ marginLeft: 'auto' }}>
                    Reset Grid
                </Button>
            )}
        </div>
    );
};
